/* src/app/pages/fotos/listafotos/listafotos.component.scss */
/*# sourceMappingURL=listafotos.component.css.map */
